// GETTERS
export const TOOLTIP_MESSAGES = 'invoice/TOOLTIP_MESSAGES'
export const INVOICES_TO_SHOW = 'invoice/INVOICES_TO_SHOW'
export const PARAMS_TO_SEND = 'invoice/PARAMS_TO_SEND'
export const ORDERED_TABLE_HEADERS = 'invoice/OREDERED_TABLE_HEADERS'
export const FILTERED_COLUMNS_ORDER = 'invoice/FILTERED_COLUMNS_ORDER'
export const SELECTED_INVOICES_BY_ACTIONS =
  'invoice/SELECTED_INVOICES_BY_ACTIONS'
export const SELECTED_INVOICES_WITH_ACTIONS =
  'invoice/SELECTED_INVOICES_WITH_ACTIONS'
export const SELECTED_INVOICES_WITH_NO_ACTIONS =
  'invoice/SELECTED_INVOICES_WITH_NO_ACTIONS'
export const ARE_TABLE_CHECKBOXES_DISABLED =
  'invoice/ARE_TABLE_CHECKBOXES_DISABLED'

// MUTATIONS
export const SET_INVOICES = 'invoice/SET_INVOICES'
export const SET_PAGINATION = 'invoice/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'invoice/SET_TOTAL_ITEMS'
export const SET_IS_TABLE_LOADING = 'invoice/SET_IS_TABLE_LOADING'
export const SET_IS_CUSTOM_COLUMNS_DIALOG_OPEN =
  'invoice/SET_IS_CUSTOM_COLUMNS_DIALOG_OPEN'
export const SET_COLUMNS_ORDER_TO_SAVE = 'invoice/SET_COLUMNS_ORDER_TO_SAVE'
export const SET_COLUMNS_ORDER = 'invoice/SET_COLUMNS_ORDER'
export const SET_SELECTED_ROWS = 'invoice/SET_SELECTED_ROWS'
export const SET_SELECTED_ACTION = 'invoice/SET_SELECTED_ACTION'
export const SET_IS_WARNING_ROW_SHOWN = 'invoice/SET_IS_WARNING_ROW_SHOWN'
export const SET_FILTERS = 'invoice/SET_FILTERS'
export const SET_ACTION_DIALOGS = 'invoice/SET_ACTION_DIALOGS'
export const SET_IS_TABLE_SELECT_ALL_MODE =
  'invoice/SET_IS_TABLE_SELECT_ALL_MODE'
export const SET_TIMELINE = 'invoice/SET_TIMELINE'

// ACTIONS
export const GET_INVOICES = 'invoice/GET_INVOICES'
export const CHANGE_PAGINATION = 'invoice/CHANGE_PAGINATION'
export const TOGGLE_CUSTOM_COLUMNS_DIALOG =
  'invoice/TOGGLE_CUSTOM_COLUMNS_DIALOG'
export const CHANGE_COLUMNS_ORDER_TO_SAVE =
  'invoice/CHANGE_COLUMNS_ORDER_TO_SAVE'
export const CHANGE_COLUMNS_ORDER = 'invoice/CHANGE_COLUMNS_ORDER'
export const CHANGE_SELECTED_ROWS = 'invoice/CHANGE_SELECTED_ROWS'
export const CHANGE_SELECTED_ACTION = 'invoice/CHANGE_SELECTED_ACTION'
export const CHANGE_IS_WARNING_ROW_SHOWN = 'invoice/CHANGE_IS_WARNING_ROW_SHOWN'
export const CHANGE_FILTERS = 'invoice/CHANGE_FILTERS'
export const RESET_PAGINATION = 'invoice/RESET_PAGINATION'
export const CHANGE_ACTION_DIALOGS = 'invoice/CHANGE_ACTION_DIALOGS'
export const CLOSE_AND_RESET_ACTION_DIALOGS =
  'invoice/CLOSE_AND_RESET_ACTION_DIALOGS'
export const CHANGE_IS_TABLE_SELECT_ALL_MODE =
  'invoice/CHANGE_IS_TABLE_SELECT_ALL_MODE'
export const CHANGE_TIMELINE = 'invoice/CHANGE_TIMELINE'
export const CLOSE_TIMELINE = 'invoice/CLOSE_TIMELINE'
export const GET_INVOICE_EVENTS = 'invoice/GET_INVOICE_EVENTS'
export const GET_INVOICE_COMMENTS = 'invoice/GET_INVOICE_COMMENTS'
